/* eslint-disable no-unused-vars */
import { Grid, IconButton, Tooltip } from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PSelect from "../../../../components/pos/PSelect";
import PText from "../../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { StringUtils } from "../../../../utils/StringUtils";
import ShippingCostAccountMappingView from "./../ShippingCostAccountMappingView";

export default function QuickPurchaseRequestSummary(props) {
  const { t } = useTranslation();
  const translate = t;
  //const [totalQuantity, setQuantity] = useState(0);
  const [showShippingCostSplitView, setShowShiipingCostSplitView] = useState();
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalShippingCost, setTotalShippingCost] = useState(0);

  useEffect(() => { }, []);

  return (
    <div>
      <hr />
      <Grid container>
        <Grid item xs={12} sm={12}>
          <table
            width="100%"
            border="1"
            style={{
              border: "1px solid ",
              borderCollapse: "collapse",
              borderColor: "#cccccc",
            }}
          >
            <tr>
              <td width="13%" style={{ borderColor: "#cccccc" }}>
                <table width="100%">
                  <tr>
                    <td>{translate("Total Quantity")}</td>
                    <td style={{ textAlign: "right" }}>
                      <b>{props.summary.qty}</b>
                    </td>
                  </tr>
                </table>
              </td>
              <td width="12%" style={{ borderColor: "#cccccc" }}>
                <table width="100%">
                  <tr>
                    <td>{translate("Without Tax")}</td>
                    <td style={{ textAlign: "right" }}>
                      <b>{props.summary.totalWoTax}</b>
                    </td>
                  </tr>
                </table>
              </td>
              <td width="5%" style={{ borderColor: "#cccccc" }}>
                <table width="100%">
                  <tr>
                    <td>{translate("Total Tax")}</td>
                    <td style={{ textAlign: "right" }}>
                      <b>{props.summary.totalTax}</b>
                    </td>
                  </tr>
                </table>
              </td>
              <td width="5%" style={{ borderColor: "#cccccc" }}>
                <table width="100%">
                  <tr>
                    <td>{translate("With Tax")}</td>
                    <td style={{ textAlign: "right" }}>
                      <b>{props.summary.total}</b>
                    </td>
                  </tr>
                </table>
              </td>
              <td width="10%" style={{ borderColor: "#cccccc" }}>
                <table width="100%">
                  <tr>
                    <td>{translate("Total Amount")}</td>
                    <td width="10%" style={{ textAlign: "right" }}>
                      <b>{props.summary.finalAmount}</b>
                    </td>
                  </tr>
                </table>
              </td>
              <td width="20%" style={{ borderColor: "#cccccc" }}>
                <table width="100%">
                  <tr>
                    <td>{translate("Invoice Amount")}</td>
                    <td style={{ textAlign: "right" }}>
                      <PText
                        value={props.amount}
                        type="number"
                        InputProps={{
                          inputProps: {
                            style: { textAlign: "right" },
                          },
                        }}
                        error={props.errorAmount}
                        onChange={(e) =>
                          props.setAmount(e.target.value)
                        }
                      ></PText>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td width="16%" style={{ borderColor: "#cccccc" }}>
                <table width="100%">
                  <tr>
                    <td>{translate("Discount Type")}</td>
                    <td>
                      <PSelect
                        options={props.discountTypeOptions}
                        value={props.summary.discountType}
                        onChange={(event, newValue) => {
                          //TODO
                          //props.setSelectedDiscountType(newValue);
                          props.updateSummaryValue("discountType", newValue);
                        }}
                      ></PSelect>
                    </td>
                  </tr>
                </table>
              </td>
              <td width="12%" style={{ borderColor: "#cccccc" }}>
                <table width="100%">
                  <tr>
                    <td width="60%">{translate("Discount Amount")}</td>
                    <td>
                      <PText
                        value={props.summary.discount}
                        type="number"
                        InputProps={{
                          inputProps: {
                            style: { textAlign: "right" },
                          },
                        }}
                        //error={invoiceNumberError}
                        onChange={(e) =>
                          props.updateSummaryValue("discount", e.target.value)
                        }
                      ></PText>
                    </td>
                  </tr>
                </table>
              </td>
              <td width="8%" style={{ borderColor: "#cccccc" }}>
                <table width="100%">
                  <tr>
                    <td>{translate("Net w/o Tax")}</td>
                    <td style={{ textAlign: "right" }}>
                      <b>{props.summary.finalAmountExTax}</b>
                    </td>
                  </tr>
                </table>
              </td>
              <td width="8%" style={{ borderColor: "#cccccc" }}>
                <table width="100%">
                  <tr>
                    <td>{translate("Net Tax")}</td>
                    <td style={{ textAlign: "right" }}>
                      <b>{props.summary.finalTax}</b>
                    </td>
                  </tr>
                </table>
              </td>

              <td width="12%" style={{ borderColor: "#cccccc" }}>
                <table width="100%">
                  <tr>
                    <td>{translate("Roundoff Amount")}</td>
                    <td style={{ textAlign: "right" }}>
                      <b>{props.roundoffAmount}</b>
                    </td>
                  </tr>
                </table>
              </td>

              <td width="12%" style={{ borderColor: "#cccccc" }}>
                <table width="100%">
                  <tr>
                    <td>{translate("Net Total Amount")}</td>
                    <td style={{ textAlign: "right" }}>
                      <b>{props.amount}</b>
                    </td>
                  </tr>
                </table>
              </td>

              {/* <table
                  width="100%"
                  border="1"
                  style={{
                    border: "1px solid ",
                    borderCollapse: "collapse",
                    borderColor: "#cccccc",
                    height: "43px",
                  }}
                > */}
              {/* <tr> */}
              {/* <td width="39%">{translate("Net w/o Tax")}</td> */}
              {/* <td width="15%" style={{ textAlign: "right" }}>
                      <b>{props.summary.finalAmountExTax}</b>
                    </td>
                    <td width="25%">{translate("Net Tax")}</td>
                    <td width="10%" style={{ textAlign: "right" }}>
                      <b>{props.summary.finalTax}</b>
                    </td> */}
              {/* <td width="50%">
                      <b>{translate("Net Amount")}</b>
                    </td>
                    <td width="15%" style={{ textAlign: "right" }}>
                      <b>{props.summary.finalAmount}</b>
                    </td> */}
              {/* </tr> */}
              {/* </table> */}
              {/* </td>{" "} */}
            </tr>
          </table>
        </Grid>
        <Grid item xs={12} sm={12}>
          <table width="100%"></table>
        </Grid>
      </Grid>
      {showShippingCostSplitView && (
        <ShippingCostAccountMappingView
          //handleApplyShippingCost={handleApplyShippingCost}
          openWindow={true}
          setOpenWindow={setShowShiipingCostSplitView}
          showMessage={props.showMessage}
          costAccountMappingList={props.costAccountMappingList}
          setCostAccountMappingList={props.setCostAccountMappingList}
          mode={props.mode}
          selectedVendor={props.selectedVendor}
          totalShippingCost={totalShippingCost}
          setTotalShippingCost={setTotalShippingCost}
          showShippingCostSplitView={showShippingCostSplitView}
        ></ShippingCostAccountMappingView>
      )}
    </div>
  );
}
